export default __webpack_public_path__ + "static/media/liz_wilcox.ecbc365e.png";